var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form',{ref:"formInfo",attrs:{"model":_vm.formInfo,"rules":_vm.rules,"label-position":"right","label-width":"120px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }